import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map, take } from 'rxjs';
import { FeatureFlagService } from '../services/feature-flag.service';

/**
 * Lets the Roleplay V2 route match only when `RoleplayV2` is on; otherwise the router falls through
 * to the legacy route declared after it. Waits for `flagsLoaded` so the page is chosen once: deciding
 * on an empty payload would render the legacy page first and then swap it out.
 */
export const roleplayV2Guard: CanMatchFn = () => {
  const featureFlagService = inject(FeatureFlagService);
  const decide = () => Boolean(featureFlagService.getFlagVariant('RoleplayV2'));

  // After boot the flags are always loaded. `toObservable` leaves an effect behind until the route's injector
  // is destroyed, so it is only for the navigations that run before the payload lands.
  if (featureFlagService.flagsLoaded()) return decide();
  return toObservable(featureFlagService.flagsLoaded).pipe(filter(Boolean), take(1), map(decide));
};
